import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('nnc/origin');
  }
}

export default new API();
